import {
	WIX_TOKEN
} from './mutationTypes';

export const mutations = {
	[WIX_TOKEN](state, wixToken) {
		state.wixToken = wixToken;
	}
};
